import React from "react";

export const Services = (props) => {
    return (
        <div id="services" className="text-center">
            <div className="container">
                <div className="section-title">
                    <h2>服務條款</h2>
                    <p>
                        歡迎來到【贏很大 Online】遊戲平台（以下簡稱本遊戲），為保障您的權益，請於註冊成為【贏很大 Online】會員並開始使用本遊戲之服務前，詳細閱讀本服務條款之所有內容。
                    </p>
                </div>
                <div className="row">
                    <ol>
                        <li>本服務條款包括(i)以下條款與規則；(ii)本應用程式的隱私條款；(iii)應用程式中之所有公告與遊戲管理規章（下合稱「遊戲規章」）以及(iv)有關本應用程式之廣告或宣傳內容。本服務條款如有疑義時，應為消費者有利之解釋。
                        </li>
                        <li>使用者開始使用本應用程式（下稱「應用程式」）的任何部分、透過應用程式或本公司網站創立使用應用程式之帳號（包含以第三方提供之身分驗證機制創立之帳號）時，視爲同意、接受和理解前條所稱之服務條款，並為使用者與本公司間契約關係之依據。
                        </li>
                        <li>本公司得隨時修改本服務條款。所有修改將公告於本應用程式之官網首頁、本應用程式之登入頁面或使用者購買頁面，並於修改後使用者第一次登入時提示。若使用者未於本公司公告後15日內為反對之表示，本公司將依修改後之服務條款繼續提供本應用程式服務。若使用者不同意本公司修改後之服務條款，依使用者終止契約方式處理。本公司未經本條款規定進行公告及通知，本服務條款之修改無效。
                        </li>
                        <li>使用者應知悉且同意，訪問和使用本站服務（包括應用程式上提供的任何或全部產品）在某些國家/地區可能是非法或受限制的。本公司對於使用者使用應用程式在使用者所在地之合法性不提供任何形式之保證與擔保。
                        </li>
                        <li>使用者認知並同意，使用者必須遵守提供應用程式之平台業者（如LINE、GooglePlay、AppStore、Facebook等提供者，下稱「平台業者」）之條款以使用應用程式。使用者同意本公司依據平台業者或使用者所使用之身分驗證機制提供者與使用者或本公司間之條款，提供本公司所收集之某些資訊予該等平台業者與身分驗證機制提供者，或自該等平台業者與身分驗證機制提供者接收您的個人資訊。
                        </li>
                        <li>使用者同意本公司利用第三方所提供之技術或服務儲存或處理使用者透過應用程式提供之個人資訊以及應用程式所收集之其他資訊，該儲存地或處理地可能與使用者實際所在之地區/國家不同。
                        </li>
                        <li><b>儲值點數、虛擬遊戲幣與虛擬商品</b>
                            <ol>
                                <li>本遊戲服務內（例如：遊戲商城、線上商店等）有提供需消費者額外付費購買之點數、商品或其他服務（例如：虛擬貨幣或寶物、道具等）。本應用程式之收費計算方式：
                                    ◎在官網或遊戲內進行儲值，無論是經由實體通路、線上轉點、電信支付、MyCard、銀行轉帳、信用卡、行動支付等支付方式，其支付幣別為新臺幣。
                                </li>
                                <li>本公司應於本應用程式之官網首頁、遊戲登入頁面或購買頁面公告載明以儲值點數兌換進行遊戲所需要的虛擬遊戲幣或其他虛擬商品之付款方式及商品資訊。
                                </li>
                                <li>前款費率調整時，本公司應於預定調整生效日30日前於本應用程式官網首頁、遊戲登入頁面或購買頁面公告；若使用者於註冊帳號時已登錄通訊資料者，依使用者登錄之通訊資料通知使用者。
                                </li>
                                <li>費率如有調整時，應自調整生效日起按新費率計收；若新費率高於舊費率時，使用者在新費率生效日前已於官網中登錄之儲值點數應依舊費率計收。
                                </li>
                                <li>使用者得在本應用程式中、透過平台業者、或其他本公司授權通路付費購買可在本應用程式中使用之儲值點數，並以儲值點數兌換進行遊戲所需要的虛擬遊戲幣或其他虛擬商品。儲值點數一經兌換為虛擬遊戲幣或虛擬商品，即為已經使用，不得請求本公司或原儲值平台退費或請求損害賠償。
                                </li>
                                <li>使用者於本應用程式中所取得之虛擬遊戲幣或其他虛擬商品，無論係使用者透過儲值點數或其他付款方式有償取得，或透過應用程式無償取得，均僅供進行應用程式中所提供遊戲之娛樂用途，不具任何交易價值。
                                    本公司保留對虛擬遊戲幣或其他虛擬商品銷售價格與發放方式之決定權。除法律或平台業者之條款另有規定外，本公司不會將已撥入使用者帳號之虛擬遊戲幣或虛擬商品兌換為金錢或其他有價值之物品，
                                    使用者亦不得以任何方式請求本公司或任何人將虛擬遊戲幣或虛擬商品兌換為金錢或其他有價值之物品。</li>
                            </ol>
                        </li>
                        <li><b>分級級別以及軟硬體需求</b>
                            <ol>
                                <li>本應用程式依遊戲軟體分級管理辦法列為【限制級十八歲】級，即十八歲以上之人始得使用本應用程式。</li>
                                <li>進行本應用程式之最低軟硬體需求：(簡要說明)
                                    ◎Android系統版本5.1以上。
                                    ◎iOS系統版本11以上。
                                    ◎記憶體2GB以上。
                                    ◎保留空間512MB以上。</li>
                                <li>本應用程式之安全裝置為：(簡要說明)
                                    本應用程式擁有簡訊驗證之功能，以綁定門號、忘記密碼等安全裝置使用之用途。</li>
                                <li>本應用程式會不定期提供付費購買之機會中獎商品或活動。但請留意，活動內容、獎項及中獎等資訊中會記載“此為機會中獎商品，消費者購買或參與活動不代表即可獲得特定商品”之說明。
                                </li>
                            </ol>
                        </li>
                        <li><b>帳號申請</b>
                            <ol>
                                <li>所有申請使用者必須是成年人(成年人之年齡依各國法律定之)或符合本站服務之最低使用年齡限制，方可申請創立帳號。同時本公司保留要求使用者提供其年齡證明以及在相關資料未提供前凍結其帳號的權利。
                                </li>
                                <li>在註冊時所提供的全部資料必須在各方面都是準確且完整的，否則相應帳號將被凍結。所有在帳號被凍結前使用應用程式進行遊戲之結果，無論其結果如何，均爲有效。
                                </li>
                                <li>透過接受條款和/或註冊使用應用程式，使用者在此同意，根據相關法律法規和/或相關監管機構要求，並出於對應用程式及本公司其他產品（包含網站與應用程式）的使用，本公司有權隨時進行任何或所有相關的身份、信用及其他方面的查核。使用者同意提供與該查核有關的所有資料。本公司有權透過任何本公司認為適當的方式，來凍結或限制使用者的帳號，直至相關查核確認通過。
                                </li>
                            </ol>
                        </li>
                        <li><b>帳號資料</b>
                            <ol>
                                <li>使用者透過應用程式或本公司網站註冊之帳號及密碼，僅供使用者使用。</li>
                                <li>使用者透過應用程式或本公司網站註冊帳號時，可以自行選擇其用戶名稱及密碼，使用者必須對該相關資料進行保密。使用者應對個人帳號中的所有活動，包含但不限於儲值、進行遊戲、與其他使用者互動等行為負責。
                                </li>
                                <li>使用者密碼得依本公司提供之修改機制進行變更。本公司不得主動詢問使用者之密碼。本公司應於本服務條款終止後30日內，保留使用者之帳號及附隨於該帳號之電磁紀錄。
                                </li>
                                <li>本服務條款非因可歸責於使用者之事由而終止者，使用者於前款期間內辦理續用後，有權繼續使用帳號及附隨於該帳號之電磁紀錄。若使用者未於前款期間屆滿時辦理續用，本公司得刪除該帳號及附隨於該帳號之所有資料，但法令另有規定者不在此限。
                                </li>
                                <li>使用者應隨時保持個人帳號中個人資訊之正確性。如本公司無法依據使用者留存之個人資料確認使用者身分，本公司有權拒絕使用者依據本契約要求提供服務。
                                </li>
                                <li>本公司保留使用者於本應用程式之活動紀錄30日，供使用者查詢。使用者得以書面、網路，或親至本公司之客服中心申請調閱使用者之帳號遊戲歷程，且須提出與身份證明文件相符之個人資料以供查驗，查詢費用為新台幣貳佰元，由使用者負擔。本公司於收到使用者之完整申請資料後，於7日內以書面、光碟或電子檔案等方式向使用者提供所申請之遊戲歷程。
                                </li>
                            </ol>
                        </li>
                        <li><b>帳號凍結/契約終止</b>
                            <ol>
                                <li>使用者得隨時關閉帳號並終止契約，請聯繫本公司辦理。</li>
                                <li>本公司保留在任何時間以任何原因關閉或凍結使用者帳號以及終止本契約的權利。於不影響前述條款效力之前提，遇下列任一情況，本公司有權在通知使用者後關閉或凍結使用者帳號以及終止本契約：
                                    <ol type="a">
                                        <li>使用者超過一年未登入使用本應用程式，且本公司通知使用者應於15日內登入後，其仍未登入使用時；
                                        </li>
                                        <li>本公司認為使用者在使用應用程式時存在冒名、詐欺或其他不正行為，或出於非法或不正當目的而購買儲值點數或遊戲內商品；
                                        </li>
                                        <li>本公司認為使用者在使用應用程式時利用外掛程式、病毒程式、遊戲程式漏洞或以其他違反遊戲常態設定或公平合理之方式進行遊戲；
                                        </li>
                                        <li>因同一事由違反遊戲規章達三次以上，經通知改善而未改善者；</li>
                                        <li>依檢警單位、任何監管機構或法庭之要求；</li>
                                        <li>本公司認為上述(b)至(d)中提及的任何情況可能已經發生或將要發生。</li>
                                    </ol>
                                </li>
                                <li>如果本公司因上述(b)至(d)中提及的任何原因而關閉或凍結使用者帳號以及終止本契約，使用者應承擔本公司蒙受的任何及全部索賠、損失、債務、損壞、成本和支出（總稱“索賠”）並且應就此類索賠對本公司進行賠償。
                                </li>
                                <li>如本公司對前項事實認定產生錯誤或無法舉證時，本公司應對使用者之損害負賠償責任。本公司將會在扣除必要成本後，於30日內依使用者指定方式退還使用者未使用儲值點數之相當金額。
                                </li>
                            </ol>
                        </li>
                        <li><b>應用程式使用</b>
                            <ol>
                                <li>倘使用者未依本應用程式所需之最低軟硬體需求使用本應用程式，因使用者所使用的設備（包含電腦或其他可使用應用程式之裝置）與網路連接皆有可能影響應用程式的性能或運行。本公司無法確保應用程式可以準確無誤地運行，或是本公司所提供的服務不會受到任何干擾。對於因使用者自身設備、網路連接或網路/通訊服務商而造成的任何故障或問題，本公司概不承擔任何責任，且遊戲結果之判定皆以本公司所接收到並儲存之資料為準。
                                </li>
                                <li>本公司之應用程式遊戲產品所產生的遊戲結果純由自然亂數機率產生，本公司盡合理努力保持遊戲內容公平公正。若使用者在使用應用程式或本公司產品時存在欺騙、不誠實或非法行為（包含但不限於利用未經授權的工具或任何方式竄改遊戲數據），本公司將尋求一切刑事及契約法律制裁的幫助。任何屬於此類範疇的使用者將被本公司回溯帳號內儲值點數、虛擬遊戲幣及／或虛擬商品之狀態，本公司亦得在通知使用者後逕行終止本契約。所有因使用者的欺騙、不誠實或非法行為而導致產生的直接或間接索賠均將由使用者自行承擔，如本公司受有損害，並應對本公司進行賠償。
                                </li>
                                <li>若發生與設置帳號或者軟體的其他性能或組成部分有關的通訊或系統故障，本公司將不會就此類故障對使用者或任何第三方負責。本公司保留在出現此類故障時從應用程式上移除所有相關產品並採取任何其他措施以更正此類故障的權利。
                                </li>
                                <li>本公司隨時可能因任何原因修改或更正應用程式上提供的產品。</li>
                                <li>本公司為維護本應用程式相關系統及軟硬體設備而預先規畫暫停本應用程式之全部或一部時，應於7日前於本應用程式官網首頁、遊戲登入頁面或購買頁面公告。但因臨時性、急迫性等不可歸責於本公司之事由所致者，例如因網路品質不良、電信設備故障、網路壅塞、斷電、天災、不可抗力之非人為因素或其他不可歸責於本公司之因素而導致使用者的損失、交易錯誤、無法傳送、接收、時間延遲或發生任何資料流失，以及交易無法適切完成等結果，不在此限。
                                </li>
                                <li>因可歸責於本公司之事由，致使用者不能連線使用本應用程式時，本公司應立即更正或修復。對於使用者無法使用期間遭扣除之儲值點數、虛擬遊戲幣及／或虛擬商品，本公司應返還之，無法返還時則提供其他合理補償。
                                </li>
                                <li>於任何情況下，包含但不限於因人為或系統發生不能預測因素所致之失誤，對於使用者遊戲結果，本公司保留最終決定權。
                                </li>
                                <li>本公司對本應用程式所提供之服務與應用程式內所提供之虛擬遊戲幣與虛擬商品全部或一部之正確性、完整性、即時性、相容性、無瑕疵性、無中斷性、精確性及無損害性不負任何明示或默示之擔保。
                                </li>
                            </ol>
                        </li>
                        <li><b>電磁紀錄</b>
                            <ol>
                                <li>本應用程式之所有電磁紀錄均屬本公司所有，本公司並應維持使用者相關電磁紀錄之完整。</li>
                                <li>使用者對於前項電磁紀錄有使用支配之權利，但不包括本應用程式範圍外之移轉、收益行為。</li>
                            </ol>
                        </li>
                        <li><b>電磁紀錄被不當移轉時之處理方式</b>
                            <ol>
                                <li>使用者或本公司如發現帳號、密碼被非法使用時，應立即通知他方並由本公司進行查證。本公司在確認有前述情事後，得暫時限制該組帳號或密碼之使用權，更換帳號或密碼予消費者，立即限制第三人就本應用程式之使用權利，並將相關處理方式揭載於遊戲規章。
                                </li>
                                <li>本公司於暫時限制遊戲使用權利之時起，即刻以書面、簡訊、電話、訊息等方式通知持有前項電磁紀錄之第三人提出說明。如該第三人未於接獲通知時起7日內提出說明，本公司應直接回復遭不當移轉之電磁紀錄予使用者，如不能回復時可採其他雙方同意之相當補償方式，並於回復後解除對相關線上遊戲使用人之限制；惟本公司有提供免費安全機制（如防盜卡、電話驗證等機制）而使用者不使用時，本公司得直接回復遭不當移轉之剩餘之電磁紀錄予使用者。
                                </li>
                                <li>持有第14.1條電磁紀錄之第三人不同意本公司前項之處理，本公司得依報案程序，循司法途徑處理。</li>
                                <li>本公司依第14.1條規定限制使用者之使用權時，在限制使用期間內，本公司不會向使用者收取費用。</li>
                                <li>使用者如有申告不實之情形致生本公司或其他線上遊戲使用人權利受損時，應負一切法律責任。</li>
                            </ol>
                        </li>
                        <li><b>本公司及使用者責任</b>
                            <ol>
                                <li>本公司應依本服務條款之規定於提供本服務時，維護其自身電腦系統符合當時科技或專業水準可合理期待之安全性。
                                </li>
                                <li>電腦系統或電磁紀錄受到破壞，或電腦系統運作異常時，本公司應於採取合理之措施後儘速予以回復</li>
                                <li>本公司違反前兩項規定或因遊戲程式漏洞致生使用者損害時，應依使用者受損害情形，負損害賠償責任。但本公司能證明其無過失者，得減輕其賠償責任。
                                </li>
                                <li>本公司電腦系統發生第二項之情況時，於完成修復並正常運作之前，本公司得不向使用者收取費用。</li>
                                <li>使用者因共用帳號、委託他人付費購買儲值點數衍生與第三人間之糾紛，本公司得不予協助處理。</li>
                            </ol>
                        </li>
                        <li><b>遊戲規章</b>
                            <ol>
                                <li>為規範本應用程式進行之方式，本公司應訂立合理公平之遊戲規章。使用者應遵守本公司公告之遊戲規章。</li>
                                <li>遊戲規章之變更依本服務條款第3條為之。</li>
                                <li>遊戲規章牴觸本服務條款時無效。</li>
                                <li>遊戲規章剝奪或限制使用者之契約上權利時無效。但下列情況除外：
                                    ◎除本服務條款另有規定外，有事實足證使用者於使用應用程式的過程中違反遊戲規章時，本公司將於遊戲網站或遊戲進行中公告，並以官方客服渠道等方式通知使用者。
                                    ◎經本公司通知改善而未改善者，本公司得依遊戲規章，按其情節輕重限制使用者之遊戲使用權利，每次最長不超過7日。
                                    ◎使用者違規情節嚴重者，本公司得依遊戲規章處以禁登或終止契約處置。</li>
                            </ol>
                        </li>
                        <li><b>申訴權利</b>
                            使用者對於本應用程式之使用上或遊戲進行與管理有任何申訴、查詢，或對於本公司依據遊戲規章所為之處置不服，可於接獲通知後7日內透過下列渠道為之：
                            <ol>

                                <li>官方LINE頻道</li>
                                <li>遊戲內聯絡客服
                                    本公司將於接獲您的申訴或查詢後15日內以書面或官方客服渠道回覆處理結果。
                                    使用者反映第三人利用外掛程式或其他影響遊戲公平性之申訴，亦同。</li>
                            </ol>
                        </li>
                        <li><b>停止營運</b>
                            <ol>
                                <li>本公司因停止本應用程式之營運而終止契約者，應於終止前30日公告於官網首頁、遊戲登入頁面或購買頁面。
                                </li>
                                <li>本公司未依前項期間公告並通知者，除應退還使用者未使用之儲值點數或遊戲費用且不得扣除必要成本外，並應提供使用者其他合理之補償。
                                </li>
                            </ol>
                        </li>
                        <li>本服務條款與相關遊戲規章之解釋及適用、以及使用者因使用應用程式而與本公司間所生之權利義務關係，雙方同意以中華民國法律為準據法。因本服務條款所生糾紛，若有訴訟必要，雙方合意以臺灣臺北地方法院為第一審管轄法院。
                        </li>
                        <li>關於個人資料之保護，依本公司隱私條款及相關法律規定處理。 【贏很大
                            Online】服務相關之所有著作及資訊，其智慧財產權、所有權或其他權利，包含但不限於著作權、商標權、專利權、營業秘密等，均為本公司或其權利人所有，除事先經本公司或其權利人之合法授權外，任何人不得擅自重製、傳輸、改作、編輯或以其他任何形式、基於任何目的加以使用，否則應負所有法律責任。
                        </li>
                        <li><b>法定代理人</b>
                            <ol>
                                <li>若使用者為限制行為能力人，使用【贏很大
                                    Online】服務時，應經使用者之法定代理人同意；若使用者為無行為能力人，應由使用者之法定代理人代為同意本服務條款。
                                </li>
                                <li>若使用者為限制行為能力人且未經法定代理人同意購買儲值點數；或無行為能力人未由法定代理人代為付費購買儲值點數，致法定代理人主張退費時，法定代理人得依官網公告流程，備妥證明文件並提出申請，經本公司確認後，退還使用者未使用之儲值點數。
                                </li>
                                <li>本公司應於官網首頁、遊戲登入頁面或購買頁面以中文明顯標示，若使用者為限制行為能力人或無行為能力人，除應符合21.1之規定外，並應於使用者之法定代理人閱讀、瞭解並同意本服務條款之所有內容後，方得使用【贏很大
                                    Online】服務，本服務條款變更時亦同。</li>
                                <li>若限制行為能力人使用詐術使本公司信其為完全行為能力人，或已得法定代理人之同意者，不適用21.1至21.3之規定。
                                </li>
                            </ol>
                        </li>
                    </ol>
                </div>
            </div>
        </div>
    );
};
